
import { mapState, mapGetters } from 'vuex';
import { defineComponent } from '@vue/composition-api';

import UserButton from '@/components/UserButton.vue';
import ScreenshotDialog from '@/components/ScreenshotDialog.vue';
import TimeoutDialog from '@/components/TimeoutDialog.vue';
import EmailDialog from '@/components/EmailDialog.vue';
import KeyboardShortcutDialog from '@/components/KeyboardShortcutDialog.vue';
import UserAvatar from '@/components/UserAvatar.vue';
import djangoClient from '@/django';

export default defineComponent({
  name: 'Navbar',
  components: {
    UserAvatar,
    UserButton,
    ScreenshotDialog,
    EmailDialog,
    TimeoutDialog,
    KeyboardShortcutDialog,
  },
  inject: ['user', 'MIQAConfig'],
  props: {
    frameView: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    emailDialog: false,
    keyboardShortcutDialog: false,
    advanceTimeoutId: null,
    documentationURL: 'https://openimaging.github.io/miqa/',
  }),
  computed: {
    ...mapState([
      'screenshots',
    ]),
    ...mapGetters([
      'currentFrame',
    ]),
    notes() {
      if (this.currentScan) {
        return this.currentScan.notes;
      }
      return [];
    },
  },
  methods: {
    async logoutUser() {
      await djangoClient.logout();
      this.$router.go('/'); // trigger re-render into oauth flow
    },
    openDocumentation() {
      window.open(this.documentationURL, '_blank');
    },
  },
});
